module.exports = __webpack_public_path__ + "img/speaker.a4328ac1.png";